const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/archive/EmptyRouterView.vue");
const Home = () => /* webpackChunkName: "Home" */ import("./../views/archive/Home.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/archive/archive_request/ArchiveRequestHome.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/archive/archive/Archive.vue");
const PatientHome = () => /* webpackChunkName: "PatientHome" */ import("./../views/archive/patient/PatientHome.vue");
const InternalService = () => /* webpackChunkName: "InternalService" */ import("../views/archive/internal_service/InternalService.vue");
const ArchiveLocalization = () => /* webpackChunkName: "ArchiveLocalizationHome" */ import("../views/archive/archive_localization/ArchiveLocalizationHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/archivo",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "archiveHome",
        component: Home,
      },
      {
        path: "gestor-pacientes",
        name: "archivePatientHome",
        component: PatientHome,
      },
      {
        path: "solicitud-archivo",
        name: "archiveArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "archivo",
        name: "archiveArchive",
        component: Archive,
      },
      {
        path: "servicio-interno",
        name: "servicioInterno",
        component: InternalService,
      },
      {
        path: "localizacion-archivo",
        name: "archiveLocalization",
        component: ArchiveLocalization,
      },
      {
        path: "documentacion",
        name: "archiveDocument",
        component: Document,
      },
    ],
  },
];
